import {useEffect, useState} from "react";

import CreateSelectEntity from "@/components/CreateSelectEntity";
import ExerciseFields from "@/components/ExerciseFields";
import VLFModal from "@/components/Modal";
import VLFSelectNew from "@/components/Input/SelectNew";

import {ExerciseAPI} from "@/api/exercise";

import {ERROR_OPERATION, REQUIRED_FIELD} from "@/utils/constants";
import {
	checkRequiredFields,
	getTextField,
	getTextAreaField,
} from "@/utils/functions";

export const phasesOptions = [
	{value: 1, label: "Momento 1"},
	{value: 2, label: "Momento 2"},
	{value: 3, label: "Momento 3"},
	{value: 4, label: "Momento 4"},
];

// Nella finestra si crea l'esercizio con i campi essenziali della libreria
const NEW_EXERCISE_FIELDS = [
	"name",
	"exerciseType",
	"objectives",
	"materials",
	"preparation",
	"rules",
];

function HandleExerciseModal(props) {
	const {open, confirm, close, initialData, handleNotification} = props;

	const [exercises, setExercises] = useState([]);
	const [saveOption, setSaveOption] = useState("select");
	const [formData, setFormData] = useState({
		currentExercise: null,
	});
	const [errors, setErrors] = useState([]);

	const getExercises = async () => {
		try {
			const response = await ExerciseAPI.list();
			setExercises(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		}
	};
	useEffect(() => {
		getExercises();
	}, []);

	useEffect(() => {
		if (initialData && exercises?.length) {
			initialData.currentPhase = phasesOptions?.find(
				(p) => p.value === parseInt(initialData.phase),
			);

			initialData.currentExercise = initialData.exercise?.id
				? exercises
						?.map((e) => ({value: e.id, label: e.name}))
						?.find((e) => e.value === initialData.exercise.id)
				: null;

			setFormData(initialData);
		}
	}, [initialData, exercises]);

	useEffect(() => {
		if (!open || saveOption === "new") {
			setFormData({});
		}
	}, [open, saveOption]);

	const defaultTextField = {
		values: formData,
		setValues: setFormData,
		errors,
		setErrors,
	};

	const requiredFields =
		saveOption === "select"
			? ["currentPhase", "currentExercise"]
			: ["currentPhase", "name", "exerciseType", "duration"];

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title={initialData?.id ? "Modifica esercizio" : "Aggiungi esercizio"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				if (
					!Number.isInteger(Number(formData.duration)) ||
					Number(formData.duration) <= 0
				) {
					errors.push("duration");
				}
				setErrors(errors);

				if (!errors.length) {
					const data =
						saveOption === "new"
							? {...formData, currentExercise: undefined}
							: formData;
					confirm(data, initialData?.id);
				}
			}}
			content={
				<div>
					<div className="row no-margin">
						<div className="col-12 padding-small">
							{!initialData?.id ? (
								<CreateSelectEntity
									currentOption={saveOption}
									setCurrentOption={setSaveOption}
								/>
							) : null}
						</div>
						<div className="col-12 padding-small">
							<VLFSelectNew
								options={phasesOptions}
								value={formData.currentPhase || ""}
								onChange={(value) => {
									setErrors([]);
									setFormData({...formData, currentPhase: value});
								}}
								required
								label="Momento"
							/>
						</div>
						{saveOption === "select" ? (
							<div className="col-12 col-lg-6 padding-small">
								<VLFSelectNew
									options={exercises.map((r) => {
										return {
											value: r.id,
											label: r.name,
										};
									})}
									value={formData.currentExercise || ""}
									onChange={(value) => {
										const {id, ...current} =
											exercises?.find((ex) => ex.id === value?.value) || {};

										setErrors([]);
										setFormData({
											...formData,
											...current,
											currentExercise: value,
										});
									}}
									required
									helperText={
										errors.indexOf("currentExercise") !== -1
											? REQUIRED_FIELD
											: ""
									}
									error={errors.indexOf("currentExercise") !== -1}
									label="Esercizio"
								/>
							</div>
						) : (
							<div className="col-12">
								<ExerciseFields
									fields={formData}
									setFields={setFormData}
									errors={errors}
									setErrors={setErrors}
									only={NEW_EXERCISE_FIELDS}
								/>
							</div>
						)}
						<div className="col-12 col-lg-6 padding-small">
							{getTextField({
								...defaultTextField,
								fieldKey: "duration",
								label: "Durata (minuti)",
								type: "number",
								required: true,
							})}
							{errors.includes("duration") && (
								<div className="Mui-error">
									La durata deve essere maggiore di zero.
								</div>
							)}
						</div>
						<div className="col-12 padding-small">
							{getTextAreaField({
								...defaultTextField,
								fieldKey: "description",
								label: "Descrizione",
								minRows: 5,
								maxRows: 10,
							})}
						</div>
						<div className="col-12 padding-small">
							{getTextAreaField({
								...defaultTextField,
								fieldKey: "notes",
								label: "Note",
								minRows: 5,
								maxRows: 10,
							})}
						</div>
					</div>
				</div>
			}
		/>
	);
}

export default HandleExerciseModal;
